import './style.css'
import React, { useEffect } from 'react';
import { useState } from 'react';

import DataQueryComponent from './component/DataQueryComponent'
import Home from './component/home/home';


import {getAvailableDatabases,checkUserPermission,getFilterObjects, getEtlNotification} from './services/api'
import { notification } from 'antd';
import Sync from './component/sync/sync';
import Sidebar from './Sidebar';


function App() {
    //const homeURL = process.env.REACT_APP_NEXUSHOME
    const [userHasAccess, setUserHasAccess] = useState(false);
    const [activeComponent, setActiveComponent] = useState('home');
    const [selectedDBCode, setSelectedDBCode] = useState('');
    const [databaseOptionsList, setDatabaseOptionsList] = useState([]);
    const [filterObjects, setFilterObjects] = useState({ raw: {}, means: {}, expt: {} });
    const [loadingFilterObjects, setLoadingFilterObjects] = useState(false)
    const [runtimeNotification, setRuntimeNotification] = useState(null)
    const [notificationApi, contextHolder] = notification.useNotification({
        maxCount: 1
    });
    const allowAccess = async () => {
        const hasAccess = await checkUserPermission();
        setUserHasAccess(hasAccess.data);
    };
    const getPipelineNotification = async () => {
  try {
    const notificationResult = await getEtlNotification();
    const first = notificationResult?.data?.[0] ?? null;
    setRuntimeNotification(first);
  } catch (err) {
    console.error("Notification fetch failed", err);
    setRuntimeNotification(null);
  }
};

    const getDataBase = async () => {
        try {
            const response = await getAvailableDatabases();
            if (!response.error) {
                if (response.data.length === 1) {
                    setSelectedDBCode(response.data[0].key);
                }
                setDatabaseOptionsList(response.data);
            } else {
                showErrorNotification();
            }
        } catch (error) {
            showErrorNotification();
        }
    };

    const showErrorNotification = () => {
        notificationApi.error({
            message: "Could not find accessible database(s)",
            description:
                "Try reloading the page or contact the administrator if the issue persists.",
            duration: 0,
            placement: "top",
        });
    };

    useEffect(() => {
        getPipelineNotification();
        allowAccess();
    }, []); // Runs once on mount

    useEffect(() => {
        if (userHasAccess) {
            getDataBase();
        }
    }, [userHasAccess]); // Runs when userHasAccess changes


    // on first load, get the available databases
   /* useEffect(() => {
        allowAccess()
        async function fetchAvailableDatabases() {
            if (userHasAccess) {
                const response = await getAvailableDatabases();
                console.log(response);
                if (!response.error) {
                    if(response.data.length === 1) {
                        setSelectedDBCode(response.data[0].value);
                    }
                    setDatabaseOptionsList(response.data);
                }
                else {
                    notificationApi.error({
                        message: 'Could not find accessible database(s)',
                        description: 'Try reloading the page or contact adminstrator if the issue persists.',
                        duration: 0,
                        placement: 'top',
                    })
                }
            }
        }
        try {
            fetchAvailableDatabases();

        }
        catch (err) {
            notificationApi.error({
                message: 'Could not find accessible database(s)',
                description: 'Try reloading the page or contact adminstrator if the issue persists.',
                duration: 0,
                placement: 'top',
            })
        }
    }, []);*/


    useEffect(() => {
        async function fetchFilterObjects() {
            if (selectedDBCode !== '') {
                try {
                    setLoadingFilterObjects(true);
                    const dropdownResult = await getFilterObjects(selectedDBCode);
                    if (dropdownResult.status === 200) {
                        const options = dropdownResult.data;
                        setFilterObjects(options);
                    }
                    else {
                        if (databaseOptionsList.length > 1) {
                            notificationApi.error({
                                message: 'Failed to load database information',
                                description: 'Try to select database again or contact administrator if the issue persists',
                                duration: 0,
                                placement: 'top',
                            })
                        }
                        else {
                            notificationApi.error({
                                message: 'Failed to load database information',
                                description: 'Try reloading the page or contact administrator if the issue persists',
                                duration: 0,
                                placement: 'top',
                            })
                        }
                        setSelectedDBCode('');
                    }
                }
                catch {
                    if (databaseOptionsList.length > 1) {
                        notificationApi.error({
                            message: 'Failed to load database information',
                            description: 'Try selecting a database again or contact administrator if issue persists',
                            duration: 0,
                            placement: 'top',
                        })
                    }
                    else {
                        notificationApi.error({
                            message: 'Failed to load database information',
                            description: 'Try reloading the page or contact administrator if the issue persists',
                            duration: 0,
                            placement: 'top',
                        })
                    }
                    setSelectedDBCode('');
                }
                finally {
                    setLoadingFilterObjects(false);
                }
            }
        }

        fetchFilterObjects();

    }, [selectedDBCode])

    const checkDbSelected = () => {
        if (selectedDBCode === '') {
            if (databaseOptionsList.length > 1) {
                notificationApi.warning({
                    message: 'No database selected',
                    description: "Select a database on the Home page",
                    duration: 0,
                    placement: 'top',
                })
            }
            else {
                notificationApi.error({
                    message: 'Could not find accessible database(s)',
                    description: 'Try reloading the page or contact administrator if the issue persists',
                    duration: 0,
                    placement: 'top',
                })
            }
        }
    }

    // removes any antd notifications
    const clearNotifications = async () => {
        notificationApi.destroy();
    }

    return (
        <>
            {contextHolder}
            {!userHasAccess ?
                <div className="mx-3 my-2" style={{ padding: "15%" }}>
                    <h1>404!!! NOT FOUND</h1>
                    <p>You do not have permission to access this app.</p>
                    <button style={{
                        width: "30%", height: "50px", border: "none",
                        borderRadius: "5px", fontSize: "20px",
                        fontWeight: "bold"

                    }}
                        onClick={() => { window.close() }}>Take Me Home</button>
                </div>
                :
                <div>
                    <Sidebar
                        etlNotification={runtimeNotification ?? {}}
                        clearNotifications={clearNotifications}
                        setActiveComponent={setActiveComponent}
                        checkDbSelected={checkDbSelected}
                        activeComponent={activeComponent}
                        loadingFilterObjects={loadingFilterObjects}
                    />

                    <div className='main'>
                        <div className="container-fluid">
                            {activeComponent === 'home' ? (
                                <Home props={{ setActiveComponent, setSelectedDBCode, checkDbSelected, databaseOptionsList, selectedDBCode, loadingFilterObjects }} />) : ''}
                            {activeComponent === 'rawData' ? (
                                <DataQueryComponent selectedDBCode={selectedDBCode}
                                    title={'Raw Data'}
                                    filterObject={filterObjects.raw}
                                    filters={['Years', 'Locations', 'Experiments', 'Traits']}
                                    requiredFilters={['Years', 'Experiments']}
                                    dataType={'raw'} />
                            ) : ''}
                            {activeComponent === 'rawDataSelectedLines' ? (
                                <DataQueryComponent selectedDBCode={selectedDBCode}
                                    title={'Raw Data - Selected Lines'}
                                    filterObject={filterObjects.raw}
                                    filters={['Years', 'Locations', 'Lines', 'Experiments', 'Traits']}
                                    requiredFilters={['Years', 'Lines', 'Experiments']}
                                    dataType={'rawLines'} />
                            ) : ''}
                            {activeComponent === 'meansData' ? (
                                <DataQueryComponent selectedDBCode={selectedDBCode}
                                    title={'Means Data'}
                                    filterObject={filterObjects.means}
                                    filters={['Years', 'Locations', 'Experiments', 'Traits']}
                                    requiredFilters={['Years', 'Experiments']}
                                    dataType={'means'} />
                            ) : ''}
                            {activeComponent === 'meansDataSelectedLines' ? (
                                <DataQueryComponent selectedDBCode={selectedDBCode}
                                    title={'Means Data - Selected Lines'}
                                    filterObject={filterObjects.means}
                                    filters={['Years', 'Locations', 'Lines', 'Experiments', 'Traits']}
                                    requiredFilters={['Years', 'Lines', 'Experiments']}
                                    dataType={'meansLines'} />
                            ) : ''}
                            {activeComponent === 'experiments' ? (
                                <DataQueryComponent selectedDBCode={selectedDBCode}
                                    title={'Experiments'}
                                    filterObject={filterObjects.expt}
                                    filters={['Years', 'Lines']}
                                    requiredFilters={['Years', 'Lines']}
                                    dataType={'expt'} />
                            ) : ''}
                            {activeComponent === 'blups' ? (
                                <DataQueryComponent selectedDBCode={selectedDBCode}
                                    title={'BLUPs Analysis'}
                                    filterObject={filterObjects.means}
                                    filters={['Years', 'Locations', 'Experiments', 'Traits']}
                                    requiredFilters={['Years', 'Experiments']}
                                    dataType={'blups'} />
                            ) : ''}
                            {/* {activeComponent === 'sync' ? (<Sync selectedDBCode={selectedDBCode} />) : ''} */}
                        </div>
                    </div>
                </div>

            }
        </>

    );
}

export default App;